'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (i) {
  switch (i) {
    case 1:
      return '0.3s';
    case 3:
      return '0.6s';
    case 2:
      return '0.9s';
    default:
      return false;
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/better-react-spinkit/dist/FoldingCube/cubeDelay.js
// module id = 405
// module chunks = 0